
<template>
  <VContainer fluid class="ma-0 pa-0" style="background: #9DA6BA">
    <!-- DESKTOP -->
    <div class="d-none d-lg-block ma-0 pa-0">
      <VRow class="pa-8 accent">
        <VCol cols="12" md="5">
          <VContainer class="d-flex justify-center text-white text-h6" style="white-space: pre-line;" fluid>
            {{ $t('PRE_FOOTER.doubts') }}
          </VContainer>
        </VCol>

        <VCol cols="12" md="2">
          <VContainer fluid>
            <div class="align-center">
              <VImg
                style="display: block; margin-left: auto; margin-right: auto;"
                :src="dreamicon"
                max-width="125px"
              />
            </div>
          </VContainer>
        </VCol>

        <VCol cols="12" md="5">
          <VContainer class="d-flex justify-center text-white" style="white-space: pre-line;" fluid>
            <table>
              <thead>
                <tr>
                  <td></td>
                  <td>
                    <div class="text-h6 font-weight-medium">
                      {{ $t('PRE_FOOTER.contacts') }}
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr class="text-h6 font-weight-light">
                  <td><VIcon color="white">mdi-email</VIcon></td>
                  <td>info@reportlake.com</td>
                </tr>
                <tr class="text-h6 font-weight-light">
                  <td><VIcon color="white">mdi-clock</VIcon></td>
                  <td>{{ $t('PRE_FOOTER.work_week') }} - 9h {{ $t('PRE_FOOTER.to') }} 18h</td>
                </tr>
                <tr class="text-h6 font-weight-light">
                  <td><VIcon color="white">mdi-phone</VIcon></td>
                  <td>+351 220 280 430</td>
                </tr>
              </tbody>
            </table>
          </VContainer>
        </VCol>
      </VRow>

      <VRow style="background: white;">
        <VCol cols="12">
          <VContainer fluid class="d-flex flex-column align-center">
            <a
              href="https://recuperarportugal.gov.pt/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Plano de Recuperação e Resiliência - Recuperar Portugal"
              style="display: block; width: 30%;"
            >
              <VImg
                max-width="100%"
                :src="p2020"
                :lazy-src="p2020"
                style="cursor: pointer;"
              />
            </a>
            <a
              href="/documents/ficha-operacao-prr-dreamdeal.pdf"
              target="_blank"
              rel="noopener noreferrer"
              class="prr-document-link"
              aria-label="Consultar ficha de operação PRR (PDF)"
            >
              <VIcon small class="mr-2">mdi-file-pdf-box</VIcon>
              Consultar ficha de operação PRR (PDF)
              <VIcon x-small class="ml-1">mdi-open-in-new</VIcon>
            </a>
          </VContainer>
        </VCol>
      </VRow>
    </div>

    <!-- MOBILE -->
    <VRow class="d-md-none ma-0 pa-0 accent mb-16 py-5">
      <VCol cols="12">
        <VContainer class="d-flex justify-center text-white text-h6 text-center" style="white-space: pre-line;" fluid>
          {{ $t('PRE_FOOTER.doubts') }}
        </VContainer>
      </VCol>

      <VCol cols="12">
        <VContainer fluid class="d-flex justify-center">
          <VImg max-width="100px" src="@/assets/icon_dream.png" />
        </VContainer>
      </VCol>

      <VCol cols="12">
        <VContainer class="d-flex justify-center text-white text-center" style="white-space: pre-line;" fluid>
          <table>
            <thead>
              <tr>
                <td></td>
                <td>
                  <div class="text-h6 font-weight-medium">
                    {{ $t('PRE_FOOTER.contacts') }}
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr class="text-h6 font-weight-light">
                <td><VIcon color="white">mdi-email</VIcon></td>
                <td>info@reportlake.com</td>
              </tr>
              <tr class="text-h6 font-weight-light">
                <td><VIcon color="white">mdi-clock</VIcon></td>
                <td>{{ $t('PRE_FOOTER.work_week') }} - 9h {{ $t('PRE_FOOTER.to') }} 18h</td>
              </tr>
              <tr class="text-h6 font-weight-light">
                <td><VIcon color="white">mdi-phone</VIcon></td>
                <td>+351 220 280 430</td>
              </tr>
            </tbody>
          </table>
        </VContainer>
      </VCol>

      <VCol cols="12" class="white">
        <VContainer fluid class="d-flex flex-column align-center">
          <a
            href="https://recuperarportugal.gov.pt/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Plano de Recuperação e Resiliência - Recuperar Portugal"
            style="display: block; width: 100%;"
          >
            <VImg
              max-width="100%"
              :src="p2020"
              :lazy-src="p2020"
              style="cursor: pointer;"
            />
          </a>
          <a
              href="/documents/ficha-operacao-prr-dreamdeal.pdf"
              target="_blank"
              rel="noopener noreferrer"
              class="prr-document-link"
              aria-label="Consultar ficha de operação PRR (PDF)"
            >
              <VIcon small class="mr-2">mdi-file-pdf-box</VIcon>
              Consultar ficha de operação PRR (PDF)
              <VIcon x-small class="ml-1">mdi-open-in-new</VIcon>
            </a>
        </VContainer>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script>
import p2020 from '@/assets/p2020/BARRA_FINANCIAMENTO/PNG/BARRA_LOGOS-03.png'
import dreamicon from '@/assets/icon_dream.png'

export default {
  name: 'PreFooter',
  data () {
    return {
      p2020,
      dreamicon
    }
  }
}
</script>

<style scoped>
.prr-document-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  color: #285d43;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  text-decoration: underline;
}
.prr-document-link:hover { color: #173b2a; }
</style>
